export default Object.freeze([
  {
    code: '010101',
    subitem: '01.01',
    name: 'Análise e desenvolvimento de sistemas',
    group: 'Análise e desenvolvimento de sistemas',
    nbs: ['1.1502.10.00', '1.1502.20.00', '1.1502.40.00', '1.1502.50.00', '1.1502.90.00', '1.1503.00.00', '1.1504.00.00', '1.1505.00.00', '1.1507.10.00', '1.1507.20.00', '1.1507.90.00'],
  },
  {
    code: '010201',
    subitem: '01.02',
    name: 'Programação',
    group: 'Programação',
    nbs: ['1.1502.10.00', '1.1502.20.00', '1.1502.90.00'],
  },
  {
    code: '010301',
    subitem: '01.03',
    name: 'Processamento de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres',
    group: 'Processamento, armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres',
    nbs: ['1.1506.10.00', '1.1506.21.00', '1.1506.22.00', '1.1506.23.00', '1.1506.29.00', '1.1506.90.00', '1.1509.00.00'],
  },
  {
    code: '010302',
    subitem: '01.03',
    name: 'Armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres',
    group: 'Processamento, armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres',
    nbs: ['1.1506.10.00', '1.1506.21.00', '1.1506.22.00', '1.1506.23.00', '1.1506.29.00', '1.1506.90.00', '1.1509.00.00'],
  },
  {
    code: '010401',
    subitem: '01.04',
    name: 'Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado, incluindo tablets, smartphones e congêneres',
    group: 'Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado, incluindo tablets, smartphones e congêneres',
    nbs: ['1.1502.10.00', '1.1502.20.00', '1.1502.90.00'],
  },
  {
    code: '010501',
    subitem: '01.05',
    name: 'Licenciamento ou cessão de direito de uso de programas de computação',
    group: 'Licenciamento ou cessão de direito de uso de programas de computação',
    nbs: ['1.1103.21.00', '1.1103.22.00', '1.1103.23.00', '1.1103.29.00', '1.1106.20.00', '1.1107.20.00'],
  },
  {
    code: '010601',
    subitem: '01.06',
    name: 'Assessoria e consultoria em informática',
    group: 'Assessoria e consultoria em informática',
    nbs: ['1.1501.10.00', '1.1501.20.00', '1.1507.10.00', '1.1507.20.00', '1.1507.90.00', '1.1510.00.00'],
  },
  {
    code: '010701',
    subitem: '01.07',
    name: 'Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados',
    group: 'Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados',
    nbs: ['1.1501.30.00', '1.1508.00.00', '1.1502.10.00', '1.1502.20.00'],
  },
  {
    code: '010801',
    subitem: '01.08',
    name: 'Planejamento, confecção, manutenção e atualização de páginas eletrônicas',
    group: 'Planejamento, confecção, manutenção e atualização de páginas eletrônicas',
    nbs: ['1.1502.30.00'],
  },
  {
    code: '010901',
    subitem: '01.09',
    name: 'Disponibilização, sem cessão definitiva, de conteúdos de áudio por meio da internet (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)',
    group: 'Disponibilização, sem cessão definitiva, de conteúdos de áudio, vídeo, imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)',
    nbs: ['1.1703.10.00', '1.1703.21.00', '1.1703.22.00', '1.1703.31.00', '1.1703.32.00', '1.1703.91.00', '1.1703.92.00', '1.1703.99.00'],
  },
  {
    code: '010902',
    subitem: '01.09',
    name: 'Disponibilização, sem cessão definitiva, de conteúdos de vídeo, imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)',
    group: 'Disponibilização, sem cessão definitiva, de conteúdos de áudio, vídeo, imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)',
    nbs: ['1.1703.10.00', '1.1703.21.00', '1.1703.22.00', '1.1703.31.00', '1.1703.32.00', '1.1703.91.00', '1.1703.92.00', '1.1703.99.00'],
  },
  {
    code: '020101',
    subitem: '02.01',
    name: 'Serviços de pesquisas e desenvolvimento de qualquer natureza',
    group: 'Serviços de pesquisas e desenvolvimento de qualquer natureza',
    nbs: ['1.1201.11.00', '1.1201.12.00', '1.1201.19.00', '1.1201.20.00', '1.1201.31.00', '1.1201.32.00', '1.1201.33.00', '1.1201.34.00', '1.1201.39.00', '1.1201.40.00', '1.1201.50.00', '1.1201.90.00', '1.1202.10.00', '1.1202.20.00', '1.1202.30.00', '1.1202.40.00', '1.1202.90.00', '1.1203.00.00'],
  },
  {
    code: '030201',
    subitem: '03.02',
    name: 'Cessão de direito de uso de marcas e de sinais de propaganda',
    group: 'Cessão de direito de uso de marcas e de sinais de propaganda',
    nbs: ['1.1103.33.00', '1.1104.20.00', '1.1106.33.00', '1.1107.33.00', '1.1108.20.00'],
  },
  {
    code: '030301',
    subitem: '03.03',
    name: 'Exploração de salões de festas, centro de convenções, stands e congêneres, para realização de eventos ou negócios de qualquer natureza',
    group: 'Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza',
    nbs: ['1.1805.31.00', '1.1806.61.00', '1.1806.62.00', '1.1806.63.00', '1.2508.00.00'],
  },
  {
    code: '030302',
    subitem: '03.03',
    name: 'Exploração de escritórios virtuais e congêneres, para realização de eventos ou negócios de qualquer natureza',
    group: 'Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza',
    nbs: ['1.1805.31.00', '1.1806.61.00', '1.1806.62.00', '1.1806.63.00', '1.2508.00.00'],
  },
  {
    code: '030303',
    subitem: '03.03',
    name: 'Exploração de quadras esportivas, estádios, ginásios, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza',
    group: 'Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza',
    nbs: ['1.1805.31.00', '1.1806.61.00', '1.1806.62.00', '1.1806.63.00', '1.2508.00.00'],
  },
  {
    code: '030304',
    subitem: '03.03',
    name: 'Exploração de auditórios, casas de espetáculos e congêneres, para realização de eventos ou negócios de qualquer natureza',
    group: 'Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza',
    nbs: ['1.1805.31.00', '1.1806.61.00', '1.1806.62.00', '1.1806.63.00', '1.2508.00.00'],
  },
  {
    code: '030305',
    subitem: '03.03',
    name: 'Exploração de parques de diversões e congêneres, para realização de eventos ou negócios de qualquer natureza',
    group: 'Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza',
    nbs: ['1.1805.31.00', '1.1806.61.00', '1.1806.62.00', '1.1806.63.00', '1.2508.00.00'],
  },
  {
    code: '030401',
    subitem: '03.04',
    name: 'Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia',
    group: 'Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza',
    nbs: ['1.1001.12.10'],
  },
  {
    code: '030402',
    subitem: '03.04',
    name: 'Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de rodovia',
    group: 'Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza',
    nbs: ['1.1001.12.10'],
  },
  {
    code: '030403',
    subitem: '03.04',
    name: 'Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de postes, cabos, dutos e condutos de qualquer natureza',
    group: 'Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza',
    nbs: ['1.1001.12.10'],
  },
  {
    code: '030501',
    subitem: '03.05',
    name: 'Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário',
    group: 'Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário',
    nbs: ['1.0105.70.00', '1.0105.50.00'],
  },
  {
    code: '040101',
    subitem: '04.01',
    name: 'Medicina',
    group: 'Medicina e biomedicina',
    nbs: ['1.2301.22.00'],
  },
  {
    code: '040102',
    subitem: '04.01',
    name: 'Biomedicina',
    group: 'Medicina e biomedicina',
    nbs: ['1.2301.22.00'],
  },
  {
    code: '040201',
    subitem: '04.02',
    name: 'Análises clínicas e congêneres',
    group: 'Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres',
    nbs: ['1.2301.93.00', '1.2301.94.00'],
  },
  {
    code: '040202',
    subitem: '04.02',
    name: 'Patologia e congêneres',
    group: 'Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres',
    nbs: ['1.2301.93.00', '1.2301.94.00'],
  },
  {
    code: '040203',
    subitem: '04.02',
    name: 'Eletricidade médica (eletroestimulação de nervos e musculos, cardioversão, etc) e congêneres',
    group: 'Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres',
    nbs: ['1.2301.93.00', '1.2301.94.00'],
  },
  {
    code: '040204',
    subitem: '04.02',
    name: 'Radioterapia, quimioterapia e congêneres',
    group: 'Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres',
    nbs: ['1.2301.93.00', '1.2301.94.00'],
  },
  {
    code: '040205',
    subitem: '04.02',
    name: 'Ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres',
    group: 'Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres',
    nbs: ['1.2301.93.00', '1.2301.94.00'],
  },
  {
    code: '040301',
    subitem: '04.03',
    name: 'Hospitais e congêneres',
    group: 'Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres',
    nbs: ['1.2301.11.00', '1.2301.12.00', '1.2301.13.00', '1.2301.14.00', '1.2301.15.00', '1.2301.19.00', '1.2301.21.00', '1.2301.93.00'],
  },
  {
    code: '040302',
    subitem: '04.03',
    name: 'Laboratórios e congêneres',
    group: 'Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres',
    nbs: ['1.2301.11.00', '1.2301.12.00', '1.2301.13.00', '1.2301.14.00', '1.2301.15.00', '1.2301.19.00', '1.2301.21.00', '1.2301.93.00'],
  },
  {
    code: '040303',
    subitem: '04.03',
    name: 'Clínicas, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres',
    group: 'Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres',
    nbs: ['1.2301.11.00', '1.2301.12.00', '1.2301.13.00', '1.2301.14.00', '1.2301.15.00', '1.2301.19.00', '1.2301.21.00', '1.2301.93.00'],
  },
  {
    code: '040401',
    subitem: '04.04',
    name: 'Instrumentação cirúrgica',
    group: 'Instrumentação cirúrgica',
    nbs: ['1.2301.11.00'],
  },
  {
    code: '040501',
    subitem: '04.05',
    name: 'Acupuntura',
    group: 'Acupuntura',
    nbs: ['1.2301.99.00'],
  },
  {
    code: '040601',
    subitem: '04.06',
    name: 'Enfermagem, inclusive serviços auxiliares',
    group: 'Enfermagem, inclusive serviços auxiliares',
    nbs: ['1.2301.91.00', '1.2301.97.00'],
  },
  {
    code: '040701',
    subitem: '04.07',
    name: 'Serviços farmacêuticos',
    group: 'Serviços farmacêuticos',
    nbs: ['1.2301.99.00'],
  },
  {
    code: '040801',
    subitem: '04.08',
    name: 'Terapia ocupacional',
    group: 'Terapia ocupacional, fisioterapia e fonoaudiologia',
    nbs: ['1.2301.92.00', '1.2301.99.00'],
  },
  {
    code: '040802',
    subitem: '04.08',
    name: 'Fisioterapia',
    group: 'Terapia ocupacional, fisioterapia e fonoaudiologia',
    nbs: ['1.2301.92.00', '1.2301.99.00'],
  },
  {
    code: '040803',
    subitem: '04.08',
    name: 'Fonoaudiologia',
    group: 'Terapia ocupacional, fisioterapia e fonoaudiologia',
    nbs: ['1.2301.92.00', '1.2301.99.00'],
  },
  {
    code: '040901',
    subitem: '04.09',
    name: 'Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental',
    group: 'Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental',
    nbs: ['1.2301.99.00'],
  },
  {
    code: '041001',
    subitem: '04.10',
    name: 'Nutrição',
    group: 'Nutrição',
    nbs: ['1.2301.99.00'],
  },
  {
    code: '041101',
    subitem: '04.11',
    name: 'Obstetrícia',
    group: 'Obstetrícia',
    nbs: ['1.2301.12.00', '1.2301.97.00'],
  },
  {
    code: '041201',
    subitem: '04.12',
    name: 'Odontologia',
    group: 'Odontologia',
    nbs: ['1.2301.23.00'],
  },
  {
    code: '041301',
    subitem: '04.13',
    name: 'Ortóptica',
    group: 'Ortóptica',
    nbs: ['1.2301.99.00'],
  },
  {
    code: '041401',
    subitem: '04.14',
    name: 'Próteses sob encomenda',
    group: 'Próteses sob encomenda',
    nbs: ['1.2301.99.00'],
  },
  {
    code: '041501',
    subitem: '04.15',
    name: 'Psicanálise',
    group: 'Psicanálise',
    nbs: ['1.2301.22.00'],
  },
  {
    code: '041601',
    subitem: '04.16',
    name: 'Psicologia',
    group: 'Psicologia',
    nbs: ['1.2301.98.00'],
  },
  {
    code: '041701',
    subitem: '04.17',
    name: 'Casas de repouso e congêneres',
    group: 'Casas de repouso e de recuperação, creches, asilos e congêneres',
    nbs: ['1.2201.11.00', '1.2302.10.00', '1.2302.21.00', '1.2302.22.00', '1.2302.23.00', '1.2303.00.00'],
  },
  {
    code: '041702',
    subitem: '04.17',
    name: 'Casas de recuperação e congêneres',
    group: 'Casas de repouso e de recuperação, creches, asilos e congêneres',
    nbs: ['1.2201.11.00', '1.2302.10.00', '1.2302.21.00', '1.2302.22.00', '1.2302.23.00', '1.2303.00.00'],
  },
  {
    code: '041703',
    subitem: '04.17',
    name: 'Creches e congêneres',
    group: 'Casas de repouso e de recuperação, creches, asilos e congêneres',
    nbs: ['1.2201.11.00', '1.2302.10.00', '1.2302.21.00', '1.2302.22.00', '1.2302.23.00', '1.2303.00.00'],
  },
  {
    code: '041704',
    subitem: '04.17',
    name: 'Asilos e congêneres',
    group: 'Casas de repouso e de recuperação, creches, asilos e congêneres',
    nbs: ['1.2201.11.00', '1.2302.10.00', '1.2302.21.00', '1.2302.22.00', '1.2302.23.00', '1.2303.00.00'],
  },
  {
    code: '041801',
    subitem: '04.18',
    name: 'Inseminação artificial, fertilização in vitro e congêneres',
    group: 'Inseminação artificial, fertilização in vitro e congêneres',
    nbs: ['1.2301.21.00'],
  },
  {
    code: '041901',
    subitem: '04.19',
    name: 'Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres',
    group: 'Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres',
    nbs: ['1.2301.95.00'],
  },
  {
    code: '042001',
    subitem: '04.20',
    name: 'Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie',
    group: 'Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie',
    nbs: ['1.2301.95.00'],
  },
  {
    code: '042101',
    subitem: '04.21',
    name: 'Unidade de atendimento, assistência ou tratamento móvel e congêneres',
    group: 'Unidade de atendimento, assistência ou tratamento móvel e congêneres',
    nbs: ['1.2301.96.00'],
  },
  {
    code: '042201',
    subitem: '04.22',
    name: 'Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalar, odontológica e congêneres',
    group: 'Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalar, odontológica e congêneres',
    nbs: ['1.0910.10.00', '1.0910.90.00'],
  },
  {
    code: '042301',
    subitem: '04.23',
    name: 'Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário',
    group: 'Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário',
    nbs: ['1.0910.10.00', '1.0910.90.00'],
  },
  {
    code: '050101',
    subitem: '05.01',
    name: 'Medicina veterinária',
    group: 'Medicina veterinária e zootecnia',
    nbs: ['1.1405.12.00', '1.1405.22.00', '1.1405.90.00'],
  },
  {
    code: '050102',
    subitem: '05.01',
    name: 'Zootecnia',
    group: 'Medicina veterinária e zootecnia',
    nbs: ['1.1405.12.00', '1.1405.22.00', '1.1405.90.00'],
  },
  {
    code: '050201',
    subitem: '05.02',
    name: 'Hospitais e congêneres, na área veterinária',
    group: 'Hospitais, clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária',
    nbs: ['1.1405.11.00', '1.1405.12.00', '1.1405.21.00', '1.1405.22.00'],
  },
  {
    code: '050202',
    subitem: '05.02',
    name: 'Clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária',
    group: 'Hospitais, clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária',
    nbs: ['1.1405.11.00', '1.1405.12.00', '1.1405.21.00', '1.1405.22.00'],
  },
  {
    code: '050301',
    subitem: '05.03',
    name: 'Laboratórios de análise na área veterinária',
    group: 'Laboratórios de análise na área veterinária',
    nbs: ['1.1405.90.00'],
  },
  {
    code: '050401',
    subitem: '05.04',
    name: 'Inseminação artificial, fertilização in vitro e congêneres',
    group: 'Inseminação artificial, fertilização in vitro e congêneres',
    nbs: ['1.1405.90.00'],
  },
  {
    code: '050501',
    subitem: '05.05',
    name: 'Bancos de sangue e de órgãos e congêneres',
    group: 'Bancos de sangue e de órgãos e congêneres',
    nbs: ['1.1405.40.00'],
  },
  {
    code: '050601',
    subitem: '05.06',
    name: 'Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie',
    group: 'Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie',
    nbs: ['1.1405.40.00'],
  },
  {
    code: '050701',
    subitem: '05.07',
    name: 'Unidade de atendimento, assistência ou tratamento móvel e congêneres',
    group: 'Unidade de atendimento, assistência ou tratamento móvel e congêneres',
    nbs: ['1.1405.12.00', '1.1405.22.00'],
  },
  {
    code: '050801',
    subitem: '05.08',
    name: 'Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres',
    group: 'Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres',
    nbs: ['1.1405.60.00'],
  },
  {
    code: '050901',
    subitem: '05.09',
    name: 'Planos de atendimento e assistência médico-veterinária',
    group: 'Planos de atendimento e assistência médico-veterinária',
    nbs: ['1.1405.50.00'],
  },
  {
    code: '060101',
    subitem: '06.01',
    name: 'Barbearia, cabeleireiros, manicuros, pedicuros e congêneres',
    group: 'Barbearia, cabeleireiros, manicuros, pedicuros e congêneres',
    nbs: ['1.2602.10.00', '1.2602.20.00'],
  },
  {
    code: '060201',
    subitem: '06.02',
    name: 'Esteticistas, tratamento de pele, depilação e congêneres',
    group: 'Esteticistas, tratamento de pele, depilação e congêneres',
    nbs: ['1.2602.20.00', '1.2602.30.00', '1.2602.90.00'],
  },
  {
    code: '060301',
    subitem: '06.03',
    name: 'Banhos, duchas, sauna, massagens e congêneres',
    group: 'Banhos, duchas, sauna, massagens e congêneres',
    nbs: ['1.2602.30.00'],
  },
  {
    code: '060401',
    subitem: '06.04',
    name: 'Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas',
    group: 'Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas',
    nbs: ['1.2205.12.00', '1.2505.90.00'],
  },
  {
    code: '060501',
    subitem: '06.05',
    name: 'Centros de emagrecimento, spa e congêneres',
    group: 'Centros de emagrecimento, spa e congêneres',
    nbs: ['1.2602.30.00', '1.2602.90.00'],
  },
  {
    code: '060601',
    subitem: '06.06',
    name: 'Aplicação de tatuagens, piercings e congêneres',
    group: 'Aplicação de tatuagens, piercings e congêneres',
    nbs: ['1.2602.90.00'],
  },
  {
    code: '070101',
    subitem: '07.01',
    name: 'Engenharia e congêneres',
    group: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres',
    nbs: ['1.1402.11.00', '1.1402.12.00', '1.1402.13.00', '1.1402.14.00', '1.1402.21.00', '1.1402.22.00', '1.1402.31.00', '1.1402.32.00', '1.1402.90.00', '1.1403.10.00', '1.1403.21.10', '1.1403.21.20', '1.1403.22.11', '1.1403.22.12', '1.1403.22.13', '1.1403.22.14', '1.1403.22.21', '1.1403.22.22', '1.1403.22.23', '1.1403.22.90', '1.1403.23.00', '1.1403.24.00', '1.1403.25.00', '1.1403.26.00', '1.1403.27.00', '1.1403.29.00', '1.1403.30.00', '1.1403.90.00', '1.1404.11.00', '1.1404.12.00', '1.1404.13.00', '1.1404.14.00', '1.1404.19.00'],
  },
  {
    code: '070102',
    subitem: '07.01',
    name: 'Agronomia e congêneres',
    group: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres',
    nbs: ['1.1402.11.00', '1.1402.12.00', '1.1402.13.00', '1.1402.14.00', '1.1402.21.00', '1.1402.22.00', '1.1402.31.00', '1.1402.32.00', '1.1402.90.00', '1.1403.10.00', '1.1403.21.10', '1.1403.21.20', '1.1403.22.11', '1.1403.22.12', '1.1403.22.13', '1.1403.22.14', '1.1403.22.21', '1.1403.22.22', '1.1403.22.23', '1.1403.22.90', '1.1403.23.00', '1.1403.24.00', '1.1403.25.00', '1.1403.26.00', '1.1403.27.00', '1.1403.29.00', '1.1403.30.00', '1.1403.90.00', '1.1404.11.00', '1.1404.12.00', '1.1404.13.00', '1.1404.14.00', '1.1404.19.00'],
  },
  {
    code: '070103',
    subitem: '07.01',
    name: 'Agrimensura e congêneres',
    group: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres',
    nbs: ['1.1402.11.00', '1.1402.12.00', '1.1402.13.00', '1.1402.14.00', '1.1402.21.00', '1.1402.22.00', '1.1402.31.00', '1.1402.32.00', '1.1402.90.00', '1.1403.10.00', '1.1403.21.10', '1.1403.21.20', '1.1403.22.11', '1.1403.22.12', '1.1403.22.13', '1.1403.22.14', '1.1403.22.21', '1.1403.22.22', '1.1403.22.23', '1.1403.22.90', '1.1403.23.00', '1.1403.24.00', '1.1403.25.00', '1.1403.26.00', '1.1403.27.00', '1.1403.29.00', '1.1403.30.00', '1.1403.90.00', '1.1404.11.00', '1.1404.12.00', '1.1404.13.00', '1.1404.14.00', '1.1404.19.00'],
  },
  {
    code: '070104',
    subitem: '07.01',
    name: 'Arquitetura, urbanismo e congêneres',
    group: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres',
    nbs: ['1.1402.11.00', '1.1402.12.00', '1.1402.13.00', '1.1402.14.00', '1.1402.21.00', '1.1402.22.00', '1.1402.31.00', '1.1402.32.00', '1.1402.90.00', '1.1403.10.00', '1.1403.21.10', '1.1403.21.20', '1.1403.22.11', '1.1403.22.12', '1.1403.22.13', '1.1403.22.14', '1.1403.22.21', '1.1403.22.22', '1.1403.22.23', '1.1403.22.90', '1.1403.23.00', '1.1403.24.00', '1.1403.25.00', '1.1403.26.00', '1.1403.27.00', '1.1403.29.00', '1.1403.30.00', '1.1403.90.00', '1.1404.11.00', '1.1404.12.00', '1.1404.13.00', '1.1404.14.00', '1.1404.19.00'],
  },
  {
    code: '070105',
    subitem: '07.01',
    name: 'Geologia e congêneres',
    group: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres',
    nbs: ['1.1402.11.00', '1.1402.12.00', '1.1402.13.00', '1.1402.14.00', '1.1402.21.00', '1.1402.22.00', '1.1402.31.00', '1.1402.32.00', '1.1402.90.00', '1.1403.10.00', '1.1403.21.10', '1.1403.21.20', '1.1403.22.11', '1.1403.22.12', '1.1403.22.13', '1.1403.22.14', '1.1403.22.21', '1.1403.22.22', '1.1403.22.23', '1.1403.22.90', '1.1403.23.00', '1.1403.24.00', '1.1403.25.00', '1.1403.26.00', '1.1403.27.00', '1.1403.29.00', '1.1403.30.00', '1.1403.90.00', '1.1404.11.00', '1.1404.12.00', '1.1404.13.00', '1.1404.14.00', '1.1404.19.00'],
  },
  {
    code: '070106',
    subitem: '07.01',
    name: 'Paisagismo e congêneres',
    group: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres',
    nbs: ['1.1402.11.00', '1.1402.12.00', '1.1402.13.00', '1.1402.14.00', '1.1402.21.00', '1.1402.22.00', '1.1402.31.00', '1.1402.32.00', '1.1402.90.00', '1.1403.10.00', '1.1403.21.10', '1.1403.21.20', '1.1403.22.11', '1.1403.22.12', '1.1403.22.13', '1.1403.22.14', '1.1403.22.21', '1.1403.22.22', '1.1403.22.23', '1.1403.22.90', '1.1403.23.00', '1.1403.24.00', '1.1403.25.00', '1.1403.26.00', '1.1403.27.00', '1.1403.29.00', '1.1403.30.00', '1.1403.90.00', '1.1404.11.00', '1.1404.12.00', '1.1404.13.00', '1.1404.14.00', '1.1404.19.00'],
  },
  {
    code: '070201',
    subitem: '07.02',
    name: 'Execução, por administração, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    group: 'Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    nbs: ['1.0101.11.00', '1.0101.12.00', '1.0101.21.00', '1.0101.22.00', '1.0101.29.00', '1.0101.30.00', '1.0102.11.00', '1.0102.12.00', '1.0102.13.00', '1.0102.20.00', '1.0102.31.00', '1.0102.32.00', '1.0102.33.00', '1.0102.34.00', '1.0102.35.10', '1.0102.35.20', '1.0102.35.30', '1.0102.41.10', '1.0102.41.20', '1.0102.41.90', '1.0102.42.10', '1.0102.42.20', '1.0102.51.00', '1.0102.52.10', '1.0102.52.20', '1.0102.53.10', '1.0102.53.20', '1.0102.61.00', '1.0102.69.00', '1.0102.70.00', '1.0102.80.00', '1.0102.90.00', '1.0103.20.00', '1.0103.30.00', '1.0103.41.00', '1.0103.42.00', '1.0104.00.00', '1.0105.11.00', '1.0105.12.00', '1.0105.21.00', '1.0105.22.00', '1.0105.30.00', '1.0105.40.00', '1.0105.50.00', '1.0105.60.00', '1.0105.90.00', '1.0106.11.00', '1.0106.19.00', '1.0106.21.00', '1.0106.22.00', '1.0106.60.00', '1.0107.30.00', '1.0107.40.00', '1.0106.32.00', '1.0106.40.00'],
  },
  {
    code: '070202',
    subitem: '07.02',
    name: 'Execução, por empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    group: 'Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    nbs: ['1.0101.11.00', '1.0101.12.00', '1.0101.21.00', '1.0101.22.00', '1.0101.29.00', '1.0101.30.00', '1.0102.11.00', '1.0102.12.00', '1.0102.13.00', '1.0102.20.00', '1.0102.31.00', '1.0102.32.00', '1.0102.33.00', '1.0102.34.00', '1.0102.35.10', '1.0102.35.20', '1.0102.35.30', '1.0102.41.10', '1.0102.41.20', '1.0102.41.90', '1.0102.42.10', '1.0102.42.20', '1.0102.51.00', '1.0102.52.10', '1.0102.52.20', '1.0102.53.10', '1.0102.53.20', '1.0102.61.00', '1.0102.69.00', '1.0102.70.00', '1.0102.80.00', '1.0102.90.00', '1.0103.20.00', '1.0103.30.00', '1.0103.41.00', '1.0103.42.00', '1.0104.00.00', '1.0105.11.00', '1.0105.12.00', '1.0105.21.00', '1.0105.22.00', '1.0105.30.00', '1.0105.40.00', '1.0105.50.00', '1.0105.60.00', '1.0105.90.00', '1.0106.11.00', '1.0106.19.00', '1.0106.21.00', '1.0106.22.00', '1.0106.60.00', '1.0107.30.00', '1.0107.40.00', '1.0106.32.00', '1.0106.40.00'],
  },
  {
    code: '070301',
    subitem: '07.03',
    name: 'Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia',
    group: 'Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia; elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia',
    nbs: ['1.1402.11.00', '1.1403.10.00', '1.1402.21.00', '1.1402.22.00'],
  },
  {
    code: '070302',
    subitem: '07.03',
    name: 'Elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia',
    group: 'Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia; elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia',
    nbs: ['1.1402.11.00', '1.1403.10.00', '1.1402.21.00', '1.1402.22.00'],
  },
  {
    code: '070401',
    subitem: '07.04',
    name: 'Demolição',
    group: 'Demolição',
    nbs: ['1.0103.10.00'],
  },
  {
    code: '070501',
    subitem: '07.05',
    name: 'Reparação, conservação e reforma de edifícios e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    group: 'Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    nbs: ['1.0101.11.00', '1.0101.12.00', '1.0101.21.00', '1.0101.22.00', '1.0101.29.00', '1.0101.30.00', '1.0102.11.00', '1.0102.12.00', '1.0102.13.00', '1.0102.20.00', '1.0102.31.00', '1.0102.32.00', '1.0102.33.00', '1.0102.34.00', '1.0102.35.10', '1.0102.35.20', '1.0102.35.30', '1.0102.41.10', '1.0102.41.20', '1.0102.41.90', '1.0102.42.10', '1.0102.42.20', '1.0102.51.00', '1.0102.52.10', '1.0102.52.20', '1.0102.53.10', '1.0102.53.20', '1.0102.61.00', '1.0102.69.00', '1.0102.70.00', '1.0102.80.00', '1.0102.90.00', '1.0107.30.00'],
  },
  {
    code: '070502',
    subitem: '07.05',
    name: 'Reparação, conservação e reforma de estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    group: 'Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)',
    nbs: ['1.0101.11.00', '1.0101.12.00', '1.0101.21.00', '1.0101.22.00', '1.0101.29.00', '1.0101.30.00', '1.0102.11.00', '1.0102.12.00', '1.0102.13.00', '1.0102.20.00', '1.0102.31.00', '1.0102.32.00', '1.0102.33.00', '1.0102.34.00', '1.0102.35.10', '1.0102.35.20', '1.0102.35.30', '1.0102.41.10', '1.0102.41.20', '1.0102.41.90', '1.0102.42.10', '1.0102.42.20', '1.0102.51.00', '1.0102.52.10', '1.0102.52.20', '1.0102.53.10', '1.0102.53.20', '1.0102.61.00', '1.0102.69.00', '1.0102.70.00', '1.0102.80.00', '1.0102.90.00', '1.0107.30.00'],
  },
  {
    code: '070601',
    subitem: '07.06',
    name: 'Colocação e instalação de tapetes, carpetes, cortinas e congêneres, com material fornecido pelo tomador do serviço',
    group: 'Colocação e instalação de tapetes, carpetes, assoalhos, cortinas, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço',
    nbs: ['1.0106.50.00', '1.0107.10.00', '1.0107.20.00', '1.0107.40.00'],
  },
  {
    code: '070602',
    subitem: '07.06',
    name: 'Colocação e instalação de assoalhos, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço',
    group: 'Colocação e instalação de tapetes, carpetes, assoalhos, cortinas, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço',
    nbs: ['1.0106.50.00', '1.0107.10.00', '1.0107.20.00', '1.0107.40.00'],
  },
  {
    code: '070701',
    subitem: '07.07',
    name: 'Recuperação, raspagem, polimento e lustração de pisos e congêneres',
    group: 'Recuperação, raspagem, polimento e lustração de pisos e congêneres',
    nbs: ['1.0107.40.00'],
  },
  {
    code: '070801',
    subitem: '07.08',
    name: 'Calafetação',
    group: 'Calafetação',
    nbs: ['1.0107.90.00'],
  },
  {
    code: '070901',
    subitem: '07.09',
    name: 'Varrição, coleta e remoção de lixo, rejeitos e outros resíduos quaisquer',
    group: 'Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer',
    nbs: ['1.2406.10.00', '1.2402.20.00', '1.2403.11.00', '1.2403.12.00', '1.2403.19.00', '1.2403.21.00', '1.2403.22.00', '1.2403.31.00', '1.2403.32.00', '1.2404.11.00', '1.2404.12.00', '1.2404.13.00', '1.2404.19.00', '1.2404.33.00'],
  },
  {
    code: '070902',
    subitem: '07.09',
    name: 'Incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer',
    group: 'Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer',
    nbs: ['1.2406.10.00', '1.2402.20.00', '1.2403.11.00', '1.2403.12.00', '1.2403.19.00', '1.2403.21.00', '1.2403.22.00', '1.2403.31.00', '1.2403.32.00', '1.2404.11.00', '1.2404.12.00', '1.2404.13.00', '1.2404.19.00', '1.2404.33.00'],
  },
  {
    code: '071001',
    subitem: '07.10',
    name: 'Limpeza, manutenção e conservação de vias e logradouros públicos, parques, jardins e congêneres',
    group: 'Limpeza, manutenção e conservação de vias e logradouros públicos, imóveis, chaminés, piscinas, parques, jardins e congêneres',
    nbs: ['1.1803.10.00', '1.1803.22.00', '1.1803.29.00', '1.2405.14.00', '1.2406.90.00', '1.2407.00.00'],
  },
  {
    code: '071002',
    subitem: '07.10',
    name: 'Limpeza, manutenção e conservação de imóveis, chaminés, piscinas e congêneres',
    group: 'Limpeza, manutenção e conservação de vias e logradouros públicos, imóveis, chaminés, piscinas, parques, jardins e congêneres',
    nbs: ['1.1803.10.00', '1.1803.22.00', '1.1803.29.00', '1.2405.14.00', '1.2406.90.00', '1.2407.00.00'],
  },
  {
    code: '071101',
    subitem: '07.11',
    name: 'Decoração',
    group: 'Decoração e jardinagem, inclusive corte e poda de árvores',
    nbs: ['1.1409.11.00', '1.1409.12.00', '1.1806.70.00'],
  },
  {
    code: '071102',
    subitem: '07.11',
    name: 'Jardinagem, inclusive corte e poda de árvores',
    group: 'Decoração e jardinagem, inclusive corte e poda de árvores',
    nbs: ['1.1409.11.00', '1.1409.12.00', '1.1806.70.00'],
  },
  {
    code: '071201',
    subitem: '07.12',
    name: 'Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos',
    group: 'Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos',
    nbs: ['1.2404.21.00', '1.2404.22.00', '1.2404.31.00', '1.2404.32.00', '1.2404.39.00', '1.2405.11.00', '1.2405.12.00', '1.2405.13.00', '1.2405.20.00', '1.2405.90.00'],
  },
  {
    code: '071301',
    subitem: '07.13',
    name: 'Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres',
    group: 'Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres',
    nbs: ['1.1803.21.00'],
  },
  {
    code: '071601',
    subitem: '07.16',
    name: 'Florestamento, reflorestamento, semeadura, adubação, reparação de solo, plantio, silagem, colheita, corte e descascamento de árvores, silvicultura, exploração florestal e dos serviços congêneres indissociáveis da formação, manutenção e colheita de florestas, para quaisquer fins e por quaisquer meios',
    group: 'Florestamento, reflorestamento, semeadura, adubação, reparação de solo, plantio, silagem, colheita, corte e descascamento de árvores, silvicultura, exploração florestal e dos serviços congêneres indissociáveis da formação, manutenção e colheita de florestas, para quaisquer fins e por quaisquer meios',
    nbs: ['1.1105.41.00', '1.1901.10.00', '1.1901.30.00', '1.0602.31.00'],
  },
  {
    code: '071701',
    subitem: '07.17',
    name: 'Escoramento, contenção de encostas e serviços congêneres',
    group: 'Escoramento, contenção de encostas e serviços congêneres',
    nbs: ['1.0105.11.00'],
  },
  {
    code: '071801',
    subitem: '07.18',
    name: 'Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres',
    group: 'Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres',
    nbs: ['1.2406.90.00'],
  },
  {
    code: '071901',
    subitem: '07.19',
    name: 'Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo',
    group: 'Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo',
    nbs: ['1.1402.15.00', '1.1403.21.10', '1.1403.21.20', '1.1403.30.00'],
  },
  {
    code: '072001',
    subitem: '07.20',
    name: 'Aerofotogrametria (inclusive interpretação), cartografia, mapeamento e congêneres',
    group: 'Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres',
    nbs: ['1.1404.21.00', '1.1404.22.00', '1.1404.19.00'],
  },
  {
    code: '072002',
    subitem: '07.20',
    name: 'Levantamentos batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres',
    group: 'Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres',
    nbs: ['1.1404.21.00', '1.1404.22.00', '1.1404.19.00'],
  },
  {
    code: '072003',
    subitem: '07.20',
    name: 'Levantamentos topográficos e congêneres',
    group: 'Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres',
    nbs: ['1.1404.21.00', '1.1404.22.00', '1.1404.19.00'],
  },
  {
    code: '072101',
    subitem: '07.21',
    name: 'Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais',
    group: 'Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais',
    nbs: ['1.1404.19.00', '1.1902.10.00', '1.1902.90.00'],
  },
  {
    code: '072201',
    subitem: '07.22',
    name: 'Nucleação e bombardeamento de nuvens e congêneres',
    group: 'Nucleação e bombardeamento de nuvens e congêneres',
    nbs: ['1.1901.10.00'],
  },
  {
    code: '080101',
    subitem: '08.01',
    name: 'Ensino regular pré-escolar, fundamental e médio',
    group: 'Ensino regular pré-escolar, fundamental, médio e superior',
    nbs: ['1.2201.11.00', '1.2201.12.00', '1.2201.19.00', '1.2201.20.00', '1.2201.30.00', '1.2202.00.00', '1.2203.10.00', '1.2203.20.00', '1.2204.10.00', '1.2204.20.00', '1.2204.30.00', '1.2204.40.00'],
  },
  {
    code: '080102',
    subitem: '08.01',
    name: 'Ensino regular superior',
    group: 'Ensino regular pré-escolar, fundamental, médio e superior',
    nbs: ['1.2201.11.00', '1.2201.12.00', '1.2201.19.00', '1.2201.20.00', '1.2201.30.00', '1.2202.00.00', '1.2203.10.00', '1.2203.20.00', '1.2204.10.00', '1.2204.20.00', '1.2204.30.00', '1.2204.40.00'],
  },
  {
    code: '080201',
    subitem: '08.02',
    name: 'Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza',
    group: 'Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza',
    nbs: ['1.2205.11.00', '1.2205.13.00', '1.2205.19.00', '1.2205.20.00'],
  },
  {
    code: '090101',
    subitem: '09.01',
    name: 'Hospedagem em hotéis, hotelaria marítima e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    group: 'Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    nbs: ['1.0303.11.00', '1.0303.12.00', '1.0303.13.00', '1.0303.14.00', '1.0303.20.00', '1.0303.90.00', '1.0304.10.00', '1.0304.20.00', '1.0304.90.00'],
  },
  {
    code: '090102',
    subitem: '09.01',
    name: 'Hospedagem em pensões, albergues, pousadas, hospedarias, ocupação por temporada com fornecimento de serviços e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    group: 'Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    nbs: ['1.0303.11.00', '1.0303.12.00', '1.0303.13.00', '1.0303.14.00', '1.0303.20.00', '1.0303.90.00', '1.0304.10.00', '1.0304.20.00', '1.0304.90.00'],
  },
  {
    code: '090103',
    subitem: '09.01',
    name: 'Hospedagem em motéis e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    group: 'Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    nbs: ['1.0303.11.00', '1.0303.12.00', '1.0303.13.00', '1.0303.14.00', '1.0303.20.00', '1.0303.90.00', '1.0304.10.00', '1.0304.20.00', '1.0304.90.00'],
  },
  {
    code: '090104',
    subitem: '09.01',
    name: 'Hospedagem em apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    group: 'Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)',
    nbs: ['1.0303.11.00', '1.0303.12.00', '1.0303.13.00', '1.0303.14.00', '1.0303.20.00', '1.0303.90.00', '1.0304.10.00', '1.0304.20.00', '1.0304.90.00'],
  },
  {
    code: '090201',
    subitem: '09.02',
    name: 'Agenciamento e intermediação de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres',
    group: 'Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres',
    nbs: ['1.0401.17.10', '1.0401.17.20', '1.0401.17.90', '1.0401.23.00', '1.0401.43.00', '1.0402.13.20', '1.1805.40.00', '1.1805.11.00', '1.1805.12.00', '1.1805.13.00', '1.1805.14.00', '1.1805.19.00', '1.1805.21.00', '1.1805.22.00', '1.1805.23.00', '1.1805.24.00', '1.1805.31.00', '1.1805.32.00', '1.1805.39.00', '1.1805.61.00', '1.1805.62.00'],
  },
  {
    code: '090202',
    subitem: '09.02',
    name: 'Organização, promoção e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres',
    group: 'Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres',
    nbs: ['1.0401.17.10', '1.0401.17.20', '1.0401.17.90', '1.0401.23.00', '1.0401.43.00', '1.0402.13.20', '1.1805.40.00', '1.1805.11.00', '1.1805.12.00', '1.1805.13.00', '1.1805.14.00', '1.1805.19.00', '1.1805.21.00', '1.1805.22.00', '1.1805.23.00', '1.1805.24.00', '1.1805.31.00', '1.1805.32.00', '1.1805.39.00', '1.1805.61.00', '1.1805.62.00'],
  },
  {
    code: '090301',
    subitem: '09.03',
    name: 'Guias de turismo',
    group: 'Guias de turismo',
    nbs: ['1.1805.50.00'],
  },
  {
    code: '100101',
    subitem: '10.01',
    name: 'Agenciamento, corretagem ou intermediação de câmbio',
    group: 'Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada',
    nbs: ['1.0906.11.00', '1.0906.12.00', '1.0910.20.00', '1.0905.90.00'],
  },
  {
    code: '100102',
    subitem: '10.01',
    name: 'Agenciamento, corretagem ou intermediação de seguros',
    group: 'Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada',
    nbs: ['1.0906.11.00', '1.0906.12.00', '1.0910.20.00', '1.0905.90.00'],
  },
  {
    code: '100103',
    subitem: '10.01',
    name: 'Agenciamento, corretagem ou intermediação de cartões de crédito',
    group: 'Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada',
    nbs: ['1.0906.11.00', '1.0906.12.00', '1.0910.20.00', '1.0905.90.00'],
  },
  {
    code: '100104',
    subitem: '10.01',
    name: 'Agenciamento, corretagem ou intermediação de planos de saúde',
    group: 'Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada',
    nbs: ['1.0906.11.00', '1.0906.12.00', '1.0910.20.00', '1.0905.90.00'],
  },
  {
    code: '100105',
    subitem: '10.01',
    name: 'Agenciamento, corretagem ou intermediação de planos de previdência privada',
    group: 'Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada',
    nbs: ['1.0906.11.00', '1.0906.12.00', '1.0910.20.00', '1.0905.90.00'],
  },
  {
    code: '100201',
    subitem: '10.02',
    name: 'Agenciamento, corretagem ou intermediação de títulos em geral e valores mobiliários',
    group: 'Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer',
    nbs: ['1.0607.00.00', '1.0905.11.00', '1.0905.12.00'],
  },
  {
    code: '100202',
    subitem: '10.02',
    name: 'Agenciamento, corretagem ou intermediação de contratos quaisquer',
    group: 'Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer',
    nbs: ['1.0607.00.00', '1.0905.11.00', '1.0905.12.00'],
  },
  {
    code: '100301',
    subitem: '10.03',
    name: 'Agenciamento, corretagem ou intermediação de direitos de propriedade industrial, artística ou literária',
    group: 'Agenciamento, corretagem ou intermediação de direitos de propriedade industrial, artística ou literária',
    nbs: ['1.2501.40.00', '1.0905.11.00'],
  },
  {
    code: '100401',
    subitem: '10.04',
    name: 'Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing)',
    group: 'Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing), de franquia (franchising) e de faturização (factoring)',
    nbs: ['1.0905.90.00'],
  },
  {
    code: '100402',
    subitem: '10.04',
    name: 'Agenciamento, corretagem ou intermediação de contratos de franquia (franchising)',
    group: 'Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing), de franquia (franchising) e de faturização (factoring)',
    nbs: ['1.0905.90.00'],
  },
  {
    code: '100403',
    subitem: '10.04',
    name: 'Agenciamento, corretagem ou intermediação de faturização (factoring)',
    group: 'Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing), de franquia (franchising) e de faturização (factoring)',
    nbs: ['1.0905.90.00'],
  },
  {
    code: '100501',
    subitem: '10.05',
    name: 'Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, por quaisquer meios',
    group: 'Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, inclusive aqueles realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios',
    nbs: ['1.1001.21.00', '1.1001.22.00', '1.0201.00.00', '1.0205.00.00', '1.0905.12.00'],
  },
  {
    code: '100502',
    subitem: '10.05',
    name: 'Agenciamento, corretagem ou intermediação de bens móveis ou imóveis realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios',
    group: 'Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, inclusive aqueles realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios',
    nbs: ['1.1001.21.00', '1.1001.22.00', '1.0201.00.00', '1.0205.00.00', '1.0905.12.00'],
  },
  {
    code: '100601',
    subitem: '10.06',
    name: 'Agenciamento marítimo',
    group: 'Agenciamento marítimo',
    nbs: ['1.0502.29.00', '1.0607.00.00'],
  },
  {
    code: '100701',
    subitem: '10.07',
    name: 'Agenciamento de notícias',
    group: 'Agenciamento de notícias',
    nbs: ['1.1704.10.00', '1.1704.20.00'],
  },
  {
    code: '100801',
    subitem: '10.08',
    name: 'Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios',
    group: 'Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios',
    nbs: ['1.1406.20.00'],
  },
  {
    code: '100901',
    subitem: '10.09',
    name: 'Representação de qualquer natureza, inclusive comercial',
    group: 'Representação de qualquer natureza, inclusive comercial',
    nbs: ['1.0201.00.00'],
  },
  {
    code: '101001',
    subitem: '10.10',
    name: 'Distribuição de bens de terceiros',
    group: 'Distribuição de bens de terceiros',
    nbs: ['1.0201.00.00'],
  },
  {
    code: '110101',
    subitem: '11.01',
    name: 'Guarda e estacionamento de veículos terrestres automotores',
    group: 'Guarda e estacionamento de veículos terrestres automotores, de aeronaves e de embarcações',
    nbs: ['1.0604.30.00', '1.0605.90.00', '1.0606.19.00'],
  },
  {
    code: '110102',
    subitem: '11.01',
    name: 'Guarda e estacionamento de aeronaves e de embarcações',
    group: 'Guarda e estacionamento de veículos terrestres automotores, de aeronaves e de embarcações',
    nbs: ['1.0604.30.00', '1.0605.90.00', '1.0606.19.00'],
  },
  {
    code: '110201',
    subitem: '11.02',
    name: 'Vigilância, segurança ou monitoramento de bens, pessoas e semoventes',
    group: 'Vigilância, segurança ou monitoramento de bens, pessoas e semoventes',
    nbs: ['1.1802.50.00', '1.1802.20.00', '1.1802.30.00', '1.1802.90.00'],
  },
  {
    code: '110301',
    subitem: '11.03',
    name: 'Escolta, inclusive de veículos e cargas',
    group: 'Escolta, inclusive de veículos e cargas',
    nbs: ['1.1802.50.00'],
  },
  {
    code: '110401',
    subitem: '11.04',
    name: 'Armazenamento, depósito, guarda de bens de qualquer espécie',
    group: 'Armazenamento, depósito, carga, descarga, arrumação e guarda de bens de qualquer espécie',
    nbs: ['1.0601.10.00', '1.0601.90.00', '1.0602.10.00', '1.0602.21.00', '1.0602.22.00', '1.0602.23.00', '1.0602.29.00', '1.0602.31.00', '1.0602.32.00', '1.0602.33.00', '1.0602.90.00', '1.0608.20.00', '1.0608.30.00'],
  },
  {
    code: '110402',
    subitem: '11.04',
    name: 'Carga, descarga, arrumação de bens de qualquer espécie',
    group: 'Armazenamento, depósito, carga, descarga, arrumação e guarda de bens de qualquer espécie',
    nbs: ['1.0601.10.00', '1.0601.90.00', '1.0602.10.00', '1.0602.21.00', '1.0602.22.00', '1.0602.23.00', '1.0602.29.00', '1.0602.31.00', '1.0602.32.00', '1.0602.33.00', '1.0602.90.00', '1.0608.20.00', '1.0608.30.00'],
  },
  {
    code: '110501',
    subitem: '11.05',
    name: 'Serviços relacionados ao monitoramento e rastreamento a distância, em qualquer via ou local, de veículos, cargas, pessoas e semoventes em circulação ou movimento, realizados por meio de telefonia móvel, transmissão de satélites, rádio ou qualquer outro meio, inclusive pelas empresas de Tecnologia da Informação Veicular, independentemente de o prestador de serviços ser proprietário ou não da infraestrutura de telecomunicações que utiliza',
    group: 'Serviços relacionados ao monitoramento e rastreamento a distância, em qualquer via ou local, de veículos, cargas, pessoas e semoventes em circulação ou movimento, realizados por meio de telefonia móvel, transmissão de satélites, rádio ou qualquer outro meio, inclusive pelas empresas de Tecnologia da Informação Veicular, independentemente de o prestador de serviços ser proprietário ou não da infraestrutura de telecomunicações que utiliza',
    nbs: ['1.1802.30.00'],
  },
  {
    code: '120101',
    subitem: '12.01',
    name: 'Espetáculos teatrais',
    group: 'Espetáculos teatrais',
    nbs: ['1.2502.20.00'],
  },
  {
    code: '120201',
    subitem: '12.02',
    name: 'Exibições cinematográficas',
    group: 'Exibições cinematográficas',
    nbs: ['1.2501.50.00'],
  },
  {
    code: '120301',
    subitem: '12.03',
    name: 'Espetáculos circenses',
    group: 'Espetáculos circenses',
    nbs: ['1.2502.20.00'],
  },
  {
    code: '120401',
    subitem: '12.04',
    name: 'Programas de auditório',
    group: 'Programas de auditório',
    nbs: ['1.2502.90.00'],
  },
  {
    code: '120501',
    subitem: '12.05',
    name: 'Parques de diversões, centros de lazer e congêneres',
    group: 'Parques de diversões, centros de lazer e congêneres',
    nbs: ['1.2504.21.00', '1.2504.22.00', '1.2507.10.00', '1.2507.90.00'],
  },
  {
    code: '120601',
    subitem: '12.06',
    name: 'Boates, taxi-dancing e congêneres',
    group: 'Boates, taxi-dancing e congêneres',
    nbs: ['1.2508.00.00'],
  },
  {
    code: '120701',
    subitem: '12.07',
    name: 'Shows, ballet, danças, desfiles, bailes, óperas, concertos, recitais, festivais e congêneres',
    group: 'Shows, ballet, danças, desfiles, bailes, óperas, concertos, recitais, festivais e congêneres',
    nbs: ['1.2502.20.00', '1.2502.90.00'],
  },
  {
    code: '120801',
    subitem: '12.08',
    name: 'Feiras, exposições, congressos e congêneres',
    group: 'Feiras, exposições, congressos e congêneres',
    nbs: ['1.1806.61.00', '1.1806.62.00', '1.1806.63.00'],
  },
  {
    code: '120901',
    subitem: '12.09',
    name: 'Bilhares',
    group: 'Bilhares, boliches e diversões eletrônicas ou não',
    nbs: ['1.2505.90.00', '1.2508.00.00'],
  },
  {
    code: '120902',
    subitem: '12.09',
    name: 'Boliches',
    group: 'Bilhares, boliches e diversões eletrônicas ou não',
    nbs: ['1.2505.90.00', '1.2508.00.00'],
  },
  {
    code: '120903',
    subitem: '12.09',
    name: 'Diversões eletrônicas ou não',
    group: 'Bilhares, boliches e diversões eletrônicas ou não',
    nbs: ['1.2505.90.00', '1.2508.00.00'],
  },
  {
    code: '121001',
    subitem: '12.10',
    name: 'Corridas e competições de animais',
    group: 'Corridas e competições de animais',
    nbs: ['1.2508.00.00', '1.2505.10.00'],
  },
  {
    code: '121101',
    subitem: '12.11',
    name: 'Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador',
    group: 'Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador',
    nbs: ['1.2505.20.00', '1.2505.90.00', '1.2505.10.00'],
  },
  {
    code: '121201',
    subitem: '12.12',
    name: 'Execução de música',
    group: 'Execução de música',
    nbs: ['1.2503.10.00'],
  },
  {
    code: '121301',
    subitem: '12.13',
    name: 'Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres',
    group: 'Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres',
    nbs: ['1.2501.21.00', '1.2501.22.00', '1.2502.10.00', '1.2502.20.00', '1.2502.30.00', '1.2505.10.00'],
  },
  {
    code: '121401',
    subitem: '12.14',
    name: 'Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo',
    group: 'Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo',
    nbs: ['1.2502.90.00'],
  },
  {
    code: '121501',
    subitem: '12.15',
    name: 'Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres',
    group: 'Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres',
    nbs: ['1.2502.90.00', '1.2502.20.00'],
  },
  {
    code: '121601',
    subitem: '12.16',
    name: 'Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres',
    group: 'Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres',
    nbs: ['1.2501.50.00', '1.2502.90.00', '1.2505.10.00'],
  },
  {
    code: '121701',
    subitem: '12.17',
    name: 'Recreação e animação, inclusive em festas e eventos de qualquer natureza',
    group: 'Recreação e animação, inclusive em festas e eventos de qualquer natureza',
    nbs: ['1.2508.00.00'],
  },
  {
    code: '130201',
    subitem: '13.02',
    name: 'Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres',
    group: 'Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres',
    nbs: ['1.2501.11.00', '1.2501.12.00', '1.2501.36.00', '1.2501.37.00', '1.2501.39.00'],
  },
  {
    code: '130301',
    subitem: '13.03',
    name: 'Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres',
    group: 'Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres',
    nbs: ['1.1408.11.00', '1.1408.12.00', '1.1408.13.00', '1.1408.14.00', '1.1408.15.00', '1.1408.19.00', '1.1408.20.00', '1.2101.23.00', '1.2501.31.00', '1.2501.32.00', '1.2501.33.00', '1.2501.34.00', '1.2501.35.00', '1.2501.36.00', '1.2501.39.00', '1.2501.90.00'],
  },
  {
    code: '130401',
    subitem: '13.04',
    name: 'Reprografia, microfilmagem e digitalização',
    group: 'Reprografia, microfilmagem e digitalização',
    nbs: ['1.1806.51.00'],
  },
  {
    code: '130501',
    subitem: '13.05',
    name: 'Composição gráfica, inclusive confecção de impressos gráficos, fotocomposição, clicheria, zincografia, litografia e fotolitografia, exceto se destinados a posterior operação de comercialização ou industrialização, ainda que incorporados, de qualquer forma, a outra mercadoria que deva ser objeto de posterior circulação, tais como bulas, rótulos, etiquetas, caixas, cartuchos, embalagens e manuais técnicos e de instrução, quando ficarão sujeitos ao ICMS',
    group: 'Composição gráfica, inclusive confecção de impressos gráficos, fotocomposição, clicheria, zincografia, litografia e fotolitografia, exceto se destinados a posterior operação de comercialização ou industrialização, ainda que incorporados, de qualquer forma, a outra mercadoria que deva ser objeto de posterior circulação, tais como bulas, rótulos, etiquetas, caixas, cartuchos, embalagens e manuais técnicos e de instrução, quando ficarão sujeitos ao ICMS',
    nbs: ['1.2101.10.00', '1.2101.21.00', '1.2101.22.00'],
  },
  {
    code: '140101',
    subitem: '14.01',
    name: 'Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)',
    group: 'Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)',
    nbs: ['1.2001.10.00', '1.2001.20.00', '1.2001.31.10', '1.2001.31.20', '1.2001.32.00', '1.2001.33.00', '1.2001.34.10', '1.2001.34.20', '1.2001.34.30', '1.2001.35.00', '1.2001.39.00', '1.2001.40.00', '1.2001.50.00', '1.2001.60.00', '1.2001.70.00', '1.2001.81.00', '1.2001.82.00', '1.2001.83.00', '1.2001.89.00', '1.2002.10.00', '1.2002.20.00', '1.2002.30.00', '1.2002.40.00', '1.2002.90.00', '1.1803.29.00'],
  },
  {
    code: '140201',
    subitem: '14.02',
    name: 'Assistência técnica',
    group: 'Assistência técnica',
    nbs: ['1.2001.10.00', '1.2001.20.00', '1.2001.31.10', '1.2001.31.20', '1.2001.32.00', '1.2001.33.00', '1.2001.34.10', '1.2001.34.20', '1.2001.34.30', '1.2001.35.00', '1.2001.39.00', '1.2001.40.00', '1.2001.50.00', '1.2001.60.00', '1.2001.70.00', '1.2001.81.00', '1.2001.82.00', '1.2001.83.00', '1.2001.89.00', '1.2002.10.00', '1.2002.20.00', '1.2002.30.00', '1.2002.40.00', '1.2002.90.00'],
  },
  {
    code: '140301',
    subitem: '14.03',
    name: 'Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)',
    group: 'Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)',
    nbs: ['1.2001.31.10'],
  },
  {
    code: '140401',
    subitem: '14.04',
    name: 'Recauchutagem ou regeneração de pneus',
    group: 'Recauchutagem ou regeneração de pneus',
    nbs: ['1.2002.90.00'],
  },
  {
    code: '140501',
    subitem: '14.05',
    name: 'Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, plastificação, costura, acabamento, polimento e congêneres de objetos quaisquer',
    group: 'Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, plastificação, costura, acabamento, polimento e congêneres de objetos quaisquer',
    nbs: ['1.1804.00.00', '1.2002.90.00'],
  },
  {
    code: '140601',
    subitem: '14.06',
    name: 'Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido',
    group: 'Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido',
    nbs: ['1.0106.12.00', '1.0106.13.00', '1.0106.14.00', '1.0106.31.00', '1.0106.32.00', '1.0106.40.00', '1.0106.90.00', '1.0107.60.00', '1.2003.10.00', '1.2003.21.10', '1.2003.21.90', '1.2003.22.00', '1.2003.23.00', '1.2003.24.00', '1.2003.25.10', '1.2003.25.20', '1.2003.26.10', '1.2003.26.90', '1.2003.29.00', '1.0106.19.00', '1.0106.60.00'],
  },
  {
    code: '140701',
    subitem: '14.07',
    name: 'Colocação de molduras e congêneres',
    group: 'Colocação de molduras e congêneres',
    nbs: ['1.2606.00.00'],
  },
  {
    code: '140801',
    subitem: '14.08',
    name: 'Encadernação, gravação e douração de livros, revistas e congêneres',
    group: 'Encadernação, gravação e douração de livros, revistas e congêneres',
    nbs: ['1.2101.22.00'],
  },
  {
    code: '140901',
    subitem: '14.09',
    name: 'Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento',
    group: 'Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento',
    nbs: ['1.2604.00.00', '1.2002.40.00'],
  },
  {
    code: '141001',
    subitem: '14.10',
    name: 'Tinturaria e lavanderia',
    group: 'Tinturaria e lavanderia',
    nbs: ['1.2601.10.00', '1.2601.20.00', '1.2601.30.00', '1.2601.40.00', '1.2601.90.00'],
  },
  {
    code: '141101',
    subitem: '14.11',
    name: 'Tapeçaria e reforma de estofamentos em geral',
    group: 'Tapeçaria e reforma de estofamentos em geral',
    nbs: ['1.2002.40.00'],
  },
  {
    code: '141201',
    subitem: '14.12',
    name: 'Funilaria e lanternagem',
    group: 'Funilaria e lanternagem',
    nbs: ['1.2001.31.10'],
  },
  {
    code: '141301',
    subitem: '14.13',
    name: 'Carpintaria',
    group: 'Carpintaria e serralheria',
    nbs: ['1.0107.50.00'],
  },
  {
    code: '141302',
    subitem: '14.13',
    name: 'Serralheria',
    group: 'Carpintaria e serralheria',
    nbs: ['1.0107.50.00'],
  },
  {
    code: '141401',
    subitem: '14.14',
    name: 'Guincho intramunicipal',
    group: 'Guincho intramunicipal, guindaste e içamento',
    nbs: ['1.0604.40.00', '1.0601.90.00'],
  },
  {
    code: '141402',
    subitem: '14.14',
    name: 'Guindaste e içamento',
    group: 'Guincho intramunicipal, guindaste e içamento',
    nbs: ['1.0604.40.00', '1.0601.90.00'],
  },
  {
    code: '150101',
    subitem: '15.01',
    name: 'Administração de fundos quaisquer e congêneres',
    group: 'Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres',
    nbs: ['1.0901.40.00', '1.0905.21.00', '1.0905.22.00', '1.0905.23.00', '1.0905.40.00', '1.0906.40.00'],
  },
  {
    code: '150102',
    subitem: '15.01',
    name: 'Administração de consórcio e congêneres',
    group: 'Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres',
    nbs: ['1.0901.40.00', '1.0905.21.00', '1.0905.22.00', '1.0905.23.00', '1.0905.40.00', '1.0906.40.00'],
  },
  {
    code: '150103',
    subitem: '15.01',
    name: 'Administração de cartão de crédito ou débito e congêneres',
    group: 'Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres',
    nbs: ['1.0901.40.00', '1.0905.21.00', '1.0905.22.00', '1.0905.23.00', '1.0905.40.00', '1.0906.40.00'],
  },
  {
    code: '150104',
    subitem: '15.01',
    name: 'Administração de carteira de clientes e congêneres',
    group: 'Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres',
    nbs: ['1.0901.40.00', '1.0905.21.00', '1.0905.22.00', '1.0905.23.00', '1.0905.40.00', '1.0906.40.00'],
  },
  {
    code: '150105',
    subitem: '15.01',
    name: 'Administração de cheques pré-datados e congêneres',
    group: 'Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres',
    nbs: ['1.0901.40.00', '1.0905.21.00', '1.0905.22.00', '1.0905.23.00', '1.0905.40.00', '1.0906.40.00'],
  },
  {
    code: '150201',
    subitem: '15.02',
    name: 'Abertura de conta-corrente no País, bem como a manutenção da referida conta ativa e inativa',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150202',
    subitem: '15.02',
    name: 'Abertura de conta-corrente no exterior, bem como a manutenção da referida conta ativa e inativa',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150203',
    subitem: '15.02',
    name: 'Abertura de conta de investimentos e aplicação no País, bem como a manutenção da referida conta ativa e inativa',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150204',
    subitem: '15.02',
    name: 'Abertura de conta de investimentos e aplicação no exterior, bem como a manutenção da referida conta ativa e inativa',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150205',
    subitem: '15.02',
    name: 'Abertura de caderneta de poupança no País, bem como a manutenção da referida conta ativa e inativa',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150206',
    subitem: '15.02',
    name: 'Abertura de caderneta de poupança no exterior, bem como a manutenção da referida conta ativa e inativa',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150207',
    subitem: '15.02',
    name: 'Abertura de contas em geral no País, não abrangida em outro subitem, bem como a manutenção das referidas contas ativas e inativas',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150208',
    subitem: '15.02',
    name: 'Abertura de contas em geral no exterior, não abrangida em outro subitem, bem como a manutenção das referidas contas ativas e inativas',
    group: 'Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00'],
  },
  {
    code: '150301',
    subitem: '15.03',
    name: 'Locação de cofres particulares',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150302',
    subitem: '15.03',
    name: 'Manutenção de cofres particulares',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150303',
    subitem: '15.03',
    name: 'Locação de terminais eletrônicos',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150304',
    subitem: '15.03',
    name: 'Manutenção de terminais eletrônicos',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150305',
    subitem: '15.03',
    name: 'Locação de terminais de atendimento',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150306',
    subitem: '15.03',
    name: 'Manutenção de terminais de atendimento',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150307',
    subitem: '15.03',
    name: 'Locação de bens e equipamentos em geral',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150308',
    subitem: '15.03',
    name: 'Manutenção de bens e equipamentos em geral',
    group: 'Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral',
    nbs: ['1.1101.90.00', '1.2001.89.00'],
  },
  {
    code: '150401',
    subitem: '15.04',
    name: 'Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres',
    group: 'Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres',
    nbs: ['1.1301.30.00', '1.1806.10.00'],
  },
  {
    code: '150501',
    subitem: '15.05',
    name: 'Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres',
    group: 'Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF ou em quaisquer outros bancos cadastrais',
    nbs: ['1.1806.10.00'],
  },
  {
    code: '150502',
    subitem: '15.05',
    name: 'Inclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF',
    group: 'Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF ou em quaisquer outros bancos cadastrais',
    nbs: ['1.1806.10.00'],
  },
  {
    code: '150503',
    subitem: '15.05',
    name: 'Exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF',
    group: 'Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF ou em quaisquer outros bancos cadastrais',
    nbs: ['1.1806.10.00'],
  },
  {
    code: '150504',
    subitem: '15.05',
    name: 'Inclusão em quaisquer outros bancos cadastrais',
    group: 'Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF ou em quaisquer outros bancos cadastrais',
    nbs: ['1.1806.10.00'],
  },
  {
    code: '150505',
    subitem: '15.05',
    name: 'Exclusão em quaisquer outros bancos cadastrais',
    group: 'Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF ou em quaisquer outros bancos cadastrais',
    nbs: ['1.1806.10.00'],
  },
  {
    code: '150601',
    subitem: '15.06',
    name: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150602',
    subitem: '15.06',
    name: 'Abono de firmas',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150603',
    subitem: '15.06',
    name: 'Coleta e entrega de documentos, bens e valores',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150604',
    subitem: '15.06',
    name: 'Comunicação com outra agência ou com a administração central',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150605',
    subitem: '15.06',
    name: 'Licenciamento eletrônico de veículos',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150606',
    subitem: '15.06',
    name: 'Transferência de veículos',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150607',
    subitem: '15.06',
    name: 'Agenciamento fiduciário ou depositário',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150608',
    subitem: '15.06',
    name: 'Devolução de bens em custódia',
    group: 'Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia',
    nbs: ['1.1301.30.00', '1.0702.00.00'],
  },
  {
    code: '150701',
    subitem: '15.07',
    name: 'Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex',
    group: 'Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e à rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo',
    nbs: ['1.0901.90.00', '1.1806.31.00'],
  },
  {
    code: '150702',
    subitem: '15.07',
    name: 'Acesso a terminais de atendimento, inclusive vinte e quatro horas',
    group: 'Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e à rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo',
    nbs: ['1.0901.90.00', '1.1806.31.00'],
  },
  {
    code: '150703',
    subitem: '15.07',
    name: 'Acesso a outro banco e à rede compartilhada',
    group: 'Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e à rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo',
    nbs: ['1.0901.90.00', '1.1806.31.00'],
  },
  {
    code: '150704',
    subitem: '15.07',
    name: 'Fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo',
    group: 'Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e à rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo',
    nbs: ['1.0901.90.00', '1.1806.31.00'],
  },
  {
    code: '150801',
    subitem: '15.08',
    name: 'Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito',
    group: 'Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins',
    nbs: ['1.0901.33.00', '1.0901.34.00', '1.0901.35.00', '1.0901.36.00', '1.0901.39.00', '1.0905.50.00'],
  },
  {
    code: '150802',
    subitem: '15.08',
    name: 'Estudo, análise e avaliação de operações de crédito',
    group: 'Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins',
    nbs: ['1.0901.33.00', '1.0901.34.00', '1.0901.35.00', '1.0901.36.00', '1.0901.39.00', '1.0905.50.00'],
  },
  {
    code: '150803',
    subitem: '15.08',
    name: 'Emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres',
    group: 'Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins',
    nbs: ['1.0901.33.00', '1.0901.34.00', '1.0901.35.00', '1.0901.36.00', '1.0901.39.00', '1.0905.50.00'],
  },
  {
    code: '150804',
    subitem: '15.08',
    name: 'Serviços relativos à abertura de crédito, para quaisquer fins',
    group: 'Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins',
    nbs: ['1.0901.33.00', '1.0901.34.00', '1.0901.35.00', '1.0901.36.00', '1.0901.39.00', '1.0905.50.00'],
  },
  {
    code: '150901',
    subitem: '15.09',
    name: 'Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing)',
    group: 'Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing)',
    nbs: ['1.0901.51.11', '1.0901.51.12', '1.0901.51.13', '1.0901.51.14', '1.0901.51.15', '1.0901.51.16', '1.0901.51.17', '1.0901.51.21', '1.0901.51.22', '1.0901.51.23', '1.0901.51.24', '1.0901.51.25', '1.0901.51.29', '1.0901.52.10', '1.0901.52.20', '1.0901.52.30', '1.0901.52.40', '1.0901.52.50', '1.0901.52.90', '1.1101.11.00', '1.1101.12.00', '1.1101.13.00', '1.1101.14.00', '1.1101.15.00', '1.1101.16.00', '1.1101.17.00', '1.1101.20.00', '1.1101.30.00', '1.1101.40.00', '1.1101.50.00', '1.1101.60.00', '1.1101.90.00', '1.1102.10.00', '1.1102.20.00', '1.1102.30.00', '1.1102.40.00', '1.1102.50.00', '1.1102.60.00', '1.1102.90.00'],
  },
  {
    code: '151001',
    subitem: '15.10',
    name: 'Serviços relacionados a cobranças em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento',
    group: 'Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; fornecimento de posição de cobrança, recebimento ou pagamento; emissão de carnês, fichas de compensação, impressos e documentos em geral',
    nbs: ['1.1806.20.00', '1.0901.90.00'],
  },
  {
    code: '151002',
    subitem: '15.10',
    name: 'Serviços relacionados a recebimentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento',
    group: 'Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; fornecimento de posição de cobrança, recebimento ou pagamento; emissão de carnês, fichas de compensação, impressos e documentos em geral',
    nbs: ['1.1806.20.00', '1.0901.90.00'],
  },
  {
    code: '151003',
    subitem: '15.10',
    name: 'Serviços relacionados a pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento',
    group: 'Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; fornecimento de posição de cobrança, recebimento ou pagamento; emissão de carnês, fichas de compensação, impressos e documentos em geral',
    nbs: ['1.1806.20.00', '1.0901.90.00'],
  },
  {
    code: '151004',
    subitem: '15.10',
    name: 'Serviços relacionados a fornecimento de posição de cobrança, recebimento ou pagamento',
    group: 'Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; fornecimento de posição de cobrança, recebimento ou pagamento; emissão de carnês, fichas de compensação, impressos e documentos em geral',
    nbs: ['1.1806.20.00', '1.0901.90.00'],
  },
  {
    code: '151005',
    subitem: '15.10',
    name: 'Serviços relacionados a emissão de carnês, fichas de compensação, impressos e documentos em geral',
    group: 'Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; fornecimento de posição de cobrança, recebimento ou pagamento; emissão de carnês, fichas de compensação, impressos e documentos em geral',
    nbs: ['1.1806.20.00', '1.0901.90.00'],
  },
  {
    code: '151101',
    subitem: '15.11',
    name: 'Devolução de títulos, protesto de títulos, sustação de protesto, manutenção de títulos, reapresentação de títulos, e demais serviços a eles relacionados',
    group: 'Devolução de títulos, protesto de títulos, sustação de protesto, manutenção de títulos, reapresentação de títulos, e demais serviços a eles relacionados',
    nbs: ['1.0901.90.00'],
  },
  {
    code: '151201',
    subitem: '15.12',
    name: 'Custódia em geral, inclusive de títulos e valores mobiliários',
    group: 'Custódia em geral, inclusive de títulos e valores mobiliários',
    nbs: ['1.0905.30.00'],
  },
  {
    code: '151301',
    subitem: '15.13',
    name: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio',
    group: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    nbs: ['1.0905.60.00'],
  },
  {
    code: '151302',
    subitem: '15.13',
    name: 'Serviços relacionados a emissão de registro de exportação ou de crédito',
    group: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    nbs: ['1.0905.60.00'],
  },
  {
    code: '151303',
    subitem: '15.13',
    name: 'Serviços relacionados a cobrança ou depósito no exterior',
    group: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    nbs: ['1.0905.60.00'],
  },
  {
    code: '151304',
    subitem: '15.13',
    name: 'Serviços relacionados a emissão, fornecimento e cancelamento de cheques de viagem',
    group: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    nbs: ['1.0905.60.00'],
  },
  {
    code: '151305',
    subitem: '15.13',
    name: 'Serviços relacionados a fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas',
    group: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    nbs: ['1.0905.60.00'],
  },
  {
    code: '151306',
    subitem: '15.13',
    name: 'Serviços relacionados a envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    group: 'Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio',
    nbs: ['1.0905.60.00'],
  },
  {
    code: '151401',
    subitem: '15.14',
    name: 'Fornecimento, emissão, reemissão de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres',
    group: 'Fornecimento, emissão, reemissão, renovação e manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres',
    nbs: ['1.0901.40.00', '1.0901.90.00'],
  },
  {
    code: '151402',
    subitem: '15.14',
    name: 'Renovação de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres',
    group: 'Fornecimento, emissão, reemissão, renovação e manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres',
    nbs: ['1.0901.40.00', '1.0901.90.00'],
  },
  {
    code: '151403',
    subitem: '15.14',
    name: 'Manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres',
    group: 'Fornecimento, emissão, reemissão, renovação e manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres',
    nbs: ['1.0901.40.00', '1.0901.90.00'],
  },
  {
    code: '151501',
    subitem: '15.15',
    name: 'Compensação de cheques e títulos quaisquer',
    group: 'Compensação de cheques e títulos quaisquer; serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00', '1.0905.13.00'],
  },
  {
    code: '151502',
    subitem: '15.15',
    name: 'Serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento',
    group: 'Compensação de cheques e títulos quaisquer; serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento',
    nbs: ['1.0901.21.00', '1.0901.22.00', '1.0901.29.00', '1.0905.13.00'],
  },
  {
    code: '151601',
    subitem: '15.16',
    name: 'Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo',
    group: 'Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo; serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral',
    nbs: ['1.0901.90.00'],
  },
  {
    code: '151602',
    subitem: '15.16',
    name: 'Serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral',
    group: 'Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo; serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral',
    nbs: ['1.0901.90.00'],
  },
  {
    code: '151701',
    subitem: '15.17',
    name: 'Emissão e fornecimento de cheques quaisquer, avulso ou por talão',
    group: 'Emissão, fornecimento, devolução, sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão',
    nbs: ['1.0901.90.00'],
  },
  {
    code: '151702',
    subitem: '15.17',
    name: 'Devolução de cheques quaisquer, avulso ou por talão',
    group: 'Emissão, fornecimento, devolução, sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão',
    nbs: ['1.0901.90.00'],
  },
  {
    code: '151703',
    subitem: '15.17',
    name: 'Sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão',
    group: 'Emissão, fornecimento, devolução, sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão',
    nbs: ['1.0901.90.00'],
  },
  {
    code: '151801',
    subitem: '15.18',
    name: 'Serviços relacionados a crédito imobiliário, de avaliação e vistoria de imóvel ou obra',
    group: 'Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário',
    nbs: ['1.0901.31.00', '1.0901.32.00', '1.1001.30.00'],
  },
  {
    code: '151802',
    subitem: '15.18',
    name: 'Serviços relacionados a crédito imobiliário, de análise técnica e jurídica',
    group: 'Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário',
    nbs: ['1.0901.31.00', '1.0901.32.00', '1.1001.30.00'],
  },
  {
    code: '151803',
    subitem: '15.18',
    name: 'Serviços relacionados a crédito imobiliário, de emissão, reemissão, alteração, transferência e renegociação de contrato',
    group: 'Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário',
    nbs: ['1.0901.31.00', '1.0901.32.00', '1.1001.30.00'],
  },
  {
    code: '151804',
    subitem: '15.18',
    name: 'Serviços relacionados a crédito imobiliário, de emissão e reemissão do termo de quitação',
    group: 'Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário',
    nbs: ['1.0901.31.00', '1.0901.32.00', '1.1001.30.00'],
  },
  {
    code: '151805',
    subitem: '15.18',
    name: 'Demais serviços relacionados a crédito imobiliário',
    group: 'Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário',
    nbs: ['1.0901.31.00', '1.0901.32.00', '1.1001.30.00'],
  },
  {
    code: '160101',
    subitem: '16.01',
    name: 'Serviços de transporte coletivo municipal rodoviário de passageiros',
    group: 'Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros',
    nbs: ['1.0401.11.19', '1.0401.16.10', '1.0401.16.20', '1.0401.16.90', '1.0401.21.10', '1.0401.21.90', '1.0401.30.00'],
  },
  {
    code: '160102',
    subitem: '16.01',
    name: 'Serviços de transporte coletivo municipal metroviário de passageiros',
    group: 'Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros',
    nbs: ['1.0401.11.19', '1.0401.16.10', '1.0401.16.20', '1.0401.16.90', '1.0401.21.10', '1.0401.21.90', '1.0401.30.00'],
  },
  {
    code: '160103',
    subitem: '16.01',
    name: 'Serviços de transporte coletivo municipal ferroviário de passageiros',
    group: 'Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros',
    nbs: ['1.0401.11.19', '1.0401.16.10', '1.0401.16.20', '1.0401.16.90', '1.0401.21.10', '1.0401.21.90', '1.0401.30.00'],
  },
  {
    code: '160104',
    subitem: '16.01',
    name: 'Serviços de transporte coletivo municipal aquaviário de passageiros',
    group: 'Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros',
    nbs: ['1.0401.11.19', '1.0401.16.10', '1.0401.16.20', '1.0401.16.90', '1.0401.21.10', '1.0401.21.90', '1.0401.30.00'],
  },
  {
    code: '160201',
    subitem: '16.02',
    name: 'Outros serviços de transporte de natureza municipal',
    group: 'Outros serviços de transporte de natureza municipal',
    nbs: ['1.0401.21.90', '1.0401.11.11', '1.0401.12.10', '1.0401.12.20', '1.0401.12.90', '1.0401.13.00', '1.0401.14.00', '1.0401.15.10', '1.0401.15.20', '1.0401.19.00', '1.0401.21.20', '1.0401.22.00', '1.0401.29.00', '1.0401.41.00', '1.0401.42.00', '1.0401.49.00', '1.0401.90.00', '1.0404.10.00', '1.0404.20.00', '1.0404.30.00', '1.0405.00.00', '1.0501.11.10', '1.0501.11.20', '1.0501.11.30', '1.0501.12.10', '1.0501.12.20', '1.0501.12.30', '1.0501.13.10', '1.0501.13.20', '1.0501.14.10', '1.0501.14.20', '1.0501.14.30', '1.0501.14.40', '1.0501.14.51', '1.0501.14.52', '1.0501.14.59', '1.0501.15.00', '1.0501.19.00', '1.0502.11.10', '1.0502.11.20', '1.0502.11.30', '1.0502.12.10', '1.0502.12.20', '1.0502.12.30', '1.0502.13.10', '1.0502.13.20', '1.0502.14.10', '1.0502.14.20', '1.0502.14.30', '1.0502.14.40', '1.0502.14.51', '1.0502.14.52', '1.0502.14.59', '1.0502.14.90', '1.0502.19.00', '1.0502.21.10', '1.0502.21.20', '1.0502.21.30', '1.0502.22.10', '1.0502.22.20', '1.0502.22.30', '1.0502.23.10', '1.0502.23.20', '1.0502.24.10', '1.0502.24.20', '1.0502.24.30', '1.0502.24.40', '1.0502.24.51', '1.0502.24.52', '1.0502.24.59', '1.0502.29.00', '1.0505.10.00', '1.0505.20.00', '1.0505.30.00'],
  },
  {
    code: '170101',
    subitem: '17.01',
    name: 'Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista',
    group: 'Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares',
    nbs: ['1.0608.40.00', '1.1001.40.00', '1.1001.50.00', '1.1001.90.00', '1.1301.30.00', '1.1303.10.00', '1.1303.20.00', '1.1401.11.00', '1.1401.13.00', '1.1401.14.00', '1.1401.15.00', '1.1401.16.00', '1.1401.17.00', '1.1401.18.00', '1.1401.19.00', '1.1401.39.00', '1.1410.10.00', '1.1410.90.00', '1.1412.00.00', '1.1413.00.00', '1.1414.00.00', '1.1407.00.00', '1.1806.10.00'],
  },
  {
    code: '170102',
    subitem: '17.01',
    name: 'Análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares',
    group: 'Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares',
    nbs: ['1.0608.40.00', '1.1001.40.00', '1.1001.50.00', '1.1001.90.00', '1.1301.30.00', '1.1303.10.00', '1.1303.20.00', '1.1401.11.00', '1.1401.13.00', '1.1401.14.00', '1.1401.15.00', '1.1401.16.00', '1.1401.17.00', '1.1401.18.00', '1.1401.19.00', '1.1401.39.00', '1.1410.10.00', '1.1410.90.00', '1.1412.00.00', '1.1413.00.00', '1.1414.00.00', '1.1407.00.00', '1.1806.10.00'],
  },
  {
    code: '170201',
    subitem: '17.02',
    name: 'Datilografia, digitação, estenografia e congêneres',
    group: 'Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra-estrutura administrativa e congêneres',
    nbs: ['1.1411.00.00', '1.1806.31.00', '1.1806.39.00', '1.1806.40.00', '1.1806.52.00', '1.1806.53.00', '1.1806.59.00'],
  },
  {
    code: '170202',
    subitem: '17.02',
    name: 'Expediente, secretaria em geral, apoio e infra-estrutura administrativa e congêneres',
    group: 'Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra-estrutura administrativa e congêneres',
    nbs: ['1.1411.00.00', '1.1806.31.00', '1.1806.39.00', '1.1806.40.00', '1.1806.52.00', '1.1806.53.00', '1.1806.59.00'],
  },
  {
    code: '170203',
    subitem: '17.02',
    name: 'Resposta audível e congêneres',
    group: 'Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra-estrutura administrativa e congêneres',
    nbs: ['1.1411.00.00', '1.1806.31.00', '1.1806.39.00', '1.1806.40.00', '1.1806.52.00', '1.1806.53.00', '1.1806.59.00'],
  },
  {
    code: '170204',
    subitem: '17.02',
    name: 'Redação, edição, revisão e congêneres',
    group: 'Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra-estrutura administrativa e congêneres',
    nbs: ['1.1411.00.00', '1.1806.31.00', '1.1806.39.00', '1.1806.40.00', '1.1806.52.00', '1.1806.53.00', '1.1806.59.00'],
  },
  {
    code: '170205',
    subitem: '17.02',
    name: 'Interpretação, tradução e congêneres',
    group: 'Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra-estrutura administrativa e congêneres',
    nbs: ['1.1411.00.00', '1.1806.31.00', '1.1806.39.00', '1.1806.40.00', '1.1806.52.00', '1.1806.53.00', '1.1806.59.00'],
  },
  {
    code: '170301',
    subitem: '17.03',
    name: 'Planejamento, coordenação, programação ou organização técnica',
    group: 'Planejamento, coordenação, programação ou organização técnica, financeira ou administrativa',
    nbs: ['1.1401.29.00', '1.1401.39.00'],
  },
  {
    code: '170302',
    subitem: '17.03',
    name: 'Planejamento, coordenação, programação ou organização financeira',
    group: 'Planejamento, coordenação, programação ou organização técnica, financeira ou administrativa',
    nbs: ['1.1401.29.00', '1.1401.39.00'],
  },
  {
    code: '170303',
    subitem: '17.03',
    name: 'Planejamento, coordenação, programação ou organização administrativa',
    group: 'Planejamento, coordenação, programação ou organização técnica, financeira ou administrativa',
    nbs: ['1.1401.29.00', '1.1401.39.00'],
  },
  {
    code: '170401',
    subitem: '17.04',
    name: 'Recrutamento, agenciamento, seleção e colocação de mão-de-obra',
    group: 'Recrutamento, agenciamento, seleção e colocação de mão-de-obra',
    nbs: ['1.1801.11.00', '1.1801.12.00'],
  },
  {
    code: '170501',
    subitem: '17.05',
    name: 'Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço',
    group: 'Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço',
    nbs: ['1.1801.21.00', '1.1801.22.00', '1.1801.29.00'],
  },
  {
    code: '170601',
    subitem: '17.06',
    name: 'Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários',
    group: 'Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários',
    nbs: ['1.1406.11.00', '1.1406.12.00', '1.1406.19.00', '1.1407.00.00'],
  },
  {
    code: '170801',
    subitem: '17.08',
    name: 'Franquia (franchising)',
    group: 'Franquia (franchising)',
    nbs: ['1.1110.00.00'],
  },
  {
    code: '170901',
    subitem: '17.09',
    name: 'Perícias, laudos, exames técnicos e análises técnicas',
    group: 'Perícias, laudos, exames técnicos e análises técnicas',
    nbs: ['1.1404.41.00', '1.1404.42.00', '1.1404.43.00', '1.1404.44.00', '1.1404.49.00'],
  },
  {
    code: '171001',
    subitem: '17.10',
    name: 'Planejamento, organização e administração de feiras, exposições, e congêneres',
    group: 'Planejamento, organização e administração de feiras, exposições, congressos e congêneres',
    nbs: ['1.1806.61.00', '1.1806.62.00', '1.1806.63.00'],
  },
  {
    code: '171002',
    subitem: '17.10',
    name: 'Planejamento, organização e administração de congressos e congêneres',
    group: 'Planejamento, organização e administração de feiras, exposições, congressos e congêneres',
    nbs: ['1.1806.61.00', '1.1806.62.00', '1.1806.63.00'],
  },
  {
    code: '171101',
    subitem: '17.11',
    name: 'Organização de festas e recepções',
    group: 'Organização de festas e recepções; bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS)',
    nbs: ['1.1806.63.00', '1.0301.10.00', '1.0301.31.00', '1.0301.39.00'],
  },
  {
    code: '171102',
    subitem: '17.11',
    name: 'Bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS)',
    group: 'Organização de festas e recepções; bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS)',
    nbs: ['1.1806.63.00', '1.0301.10.00', '1.0301.31.00', '1.0301.39.00'],
  },
  {
    code: '171201',
    subitem: '17.12',
    name: 'Administração em geral, inclusive de bens e negócios de terceiros',
    group: 'Administração em geral, inclusive de bens e negócios de terceiros',
    nbs: ['1.1001.11.00', '1.1001.12.90', '1.1401.21.00', '1.1401.22.00'],
  },
  {
    code: '171301',
    subitem: '17.13',
    name: 'Leilão e congêneres',
    group: 'Leilão e congêneres',
    nbs: ['1.1806.90.00'],
  },
  {
    code: '171401',
    subitem: '17.14',
    name: 'Advocacia',
    group: 'Advocacia',
    nbs: ['1.1301.10.00', '1.1301.20.00', '1.1301.90.00'],
  },
  {
    code: '171501',
    subitem: '17.15',
    name: 'Arbitragem de qualquer espécie, inclusive jurídica',
    group: 'Arbitragem de qualquer espécie, inclusive jurídica',
    nbs: ['1.1301.40.00'],
  },
  {
    code: '171601',
    subitem: '17.16',
    name: 'Auditoria',
    group: 'Auditoria',
    nbs: ['1.1302.11.00', '1.1302.19.00'],
  },
  {
    code: '171701',
    subitem: '17.17',
    name: 'Análise de Organização e Métodos',
    group: 'Análise de Organização e Métodos',
    nbs: ['1.1806.90.00'],
  },
  {
    code: '171801',
    subitem: '17.18',
    name: 'Atuária e cálculos técnicos de qualquer natureza',
    group: 'Atuária e cálculos técnicos de qualquer natureza',
    nbs: ['1.0906.30.00'],
  },
  {
    code: '171901',
    subitem: '17.19',
    name: 'Contabilidade, inclusive serviços técnicos e auxiliares',
    group: 'Contabilidade, inclusive serviços técnicos e auxiliares',
    nbs: ['1.1302.21.00', '1.1302.22.00', '1.1302.23.00'],
  },
  {
    code: '172001',
    subitem: '17.20',
    name: 'Consultoria e assessoria econômica ou financeira',
    group: 'Consultoria e assessoria econômica ou financeira',
    nbs: ['1.0905.50.00', '1.0905.70.00', '1.0905.80.00', '1.1401.12.00'],
  },
  {
    code: '172101',
    subitem: '17.21',
    name: 'Estatística',
    group: 'Estatística',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '172201',
    subitem: '17.22',
    name: 'Cobrança em geral',
    group: 'Cobrança em geral',
    nbs: ['1.1806.20.00'],
  },
  {
    code: '172301',
    subitem: '17.23',
    name: 'Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring)',
    group: 'Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring)',
    nbs: ['1.0908.00.00'],
  },
  {
    code: '172401',
    subitem: '17.24',
    name: 'Apresentação de palestras, conferências, seminários e congêneres',
    group: 'Apresentação de palestras, conferências, seminários e congêneres',
    nbs: ['1.2205.14.00'],
  },
  {
    code: '172501',
    subitem: '17.25',
    name: 'Inserção de textos, desenhos e outros materiais de propaganda e publicidade, em qualquer meio (exceto em livros, jornais, periódicos e nas modalidades de serviços de radiodifusão sonora e de sons e imagens de recepção livre e gratuita)',
    group: 'Inserção de textos, desenhos e outros materiais de propaganda e publicidade, em qualquer meio (exceto em livros, jornais, periódicos e nas modalidades de serviços de radiodifusão sonora e de sons e imagens de recepção livre e gratuita)',
    nbs: ['1.1406.33.00', '1.1406.34.00', '1.1406.39.00'],
  },
  {
    code: '180101',
    subitem: '18.01',
    name: 'Serviços de regulação de sinistros vinculados a contratos de seguros e congêneres',
    group: 'Serviços de regulação de sinistros vinculados a contratos de seguros; inspeção e avaliação de riscos para cobertura de contratos de seguros; prevenção e gerência de riscos seguráveis e congêneres',
    nbs: ['1.0906.20.00'],
  },
  {
    code: '180102',
    subitem: '18.01',
    name: 'Serviços de inspeção e avaliação de riscos para cobertura de contratos de seguros e congêneres',
    group: 'Serviços de regulação de sinistros vinculados a contratos de seguros; inspeção e avaliação de riscos para cobertura de contratos de seguros; prevenção e gerência de riscos seguráveis e congêneres',
    nbs: ['1.0906.20.00'],
  },
  {
    code: '180103',
    subitem: '18.01',
    name: 'Serviços de prevenção e gerência de riscos seguráveis e congêneres',
    group: 'Serviços de regulação de sinistros vinculados a contratos de seguros; inspeção e avaliação de riscos para cobertura de contratos de seguros; prevenção e gerência de riscos seguráveis e congêneres',
    nbs: ['1.0906.20.00'],
  },
  {
    code: '190101',
    subitem: '19.01',
    name: 'Serviços de distribuição e venda de bilhetes e demais produtos de loteria, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres',
    group: 'Serviços de distribuição e venda de bilhetes e demais produtos de loteria, bingos, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres',
    nbs: ['1.0905.11.00'],
  },
  {
    code: '190102',
    subitem: '19.01',
    name: 'Serviços de distribuição e venda de bingos e congêneres',
    group: 'Serviços de distribuição e venda de bilhetes e demais produtos de loteria, bingos, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres',
    nbs: ['1.0905.11.00'],
  },
  {
    code: '200101',
    subitem: '20.01',
    name: 'Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres',
    group: 'Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres',
    nbs: ['1.0401.21.20', '1.0601.10.00', '1.0601.90.00', '1.0605.10.00', '1.0605.20.00', '1.0605.30.00', '1.0605.40.00', '1.0605.90.00', '1.0602.10.00', '1.0602.21.00', '1.0602.22.00', '1.0602.23.00', '1.0602.29.00', '1.0602.31.00', '1.0602.32.00', '1.0602.33.00', '1.0602.90.00'],
  },
  {
    code: '200201',
    subitem: '20.02',
    name: 'Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres',
    group: 'Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres',
    nbs: ['1.0601.90.00', '1.0602.90.00', '1.0606.11.00', '1.0606.12.00', '1.0606.19.00', '1.0606.20.00'],
  },
  {
    code: '200301',
    subitem: '20.03',
    name: 'Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações, logística e congêneres',
    group: 'Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações, logística e congêneres',
    nbs: ['1.0601.90.00', '1.0603.00.00', '1.0604.10.00', '1.0604.90.00'],
  },
  {
    code: '210101',
    subitem: '21.01',
    name: 'Serviços de registros públicos, cartorários e notariais',
    group: 'Serviços de registros públicos, cartorários e notariais',
    nbs: ['1.1304.00.00'],
  },
  {
    code: '220101',
    subitem: '22.01',
    name: 'Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, manutenção, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais',
    group: 'Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, manutenção, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais',
    nbs: ['1.0604.21.00', '1.0604.22.00'],
  },
  {
    code: '230101',
    subitem: '23.01',
    name: 'Serviços de programação e comunicação visual e congêneres',
    group: 'Serviços de programação e comunicação visual, desenho industrial e congêneres',
    nbs: ['1.1409.21.00', '1.1409.22.00', '1.1409.23.00', '1.1409.24.00', '1.1409.25.00', '1.1409.29.00', '1.1409.30.00', '1.1409.90.00'],
  },
  {
    code: '230102',
    subitem: '23.01',
    name: 'Serviços de desenho industrial e congêneres',
    group: 'Serviços de programação e comunicação visual, desenho industrial e congêneres',
    nbs: ['1.1409.21.00', '1.1409.22.00', '1.1409.23.00', '1.1409.24.00', '1.1409.25.00', '1.1409.29.00', '1.1409.30.00', '1.1409.90.00'],
  },
  {
    code: '240101',
    subitem: '24.01',
    name: 'Serviços de chaveiros, confecção de carimbos e congêneres',
    group: 'Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres',
    nbs: ['1.2606.00.00'],
  },
  {
    code: '240102',
    subitem: '24.01',
    name: 'Serviços de placas, sinalização visual, banners, adesivos e congêneres',
    group: 'Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres',
    nbs: ['1.2606.00.00'],
  },
  {
    code: '250101',
    subitem: '25.01',
    name: 'Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres',
    group: 'Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres',
    nbs: ['1.1405.30.00', '1.2603.00.00'],
  },
  {
    code: '250201',
    subitem: '25.02',
    name: 'Translado intramunicipal de corpos e partes de corpos cadavéricos',
    group: 'Translado intramunicipal e cremação de corpos e partes de corpos cadavéricos',
    nbs: ['1.1405.30.00', '1.2603.00.00'],
  },
  {
    code: '250202',
    subitem: '25.02',
    name: 'Cremação de corpos e partes de corpos cadavéricos',
    group: 'Translado intramunicipal e cremação de corpos e partes de corpos cadavéricos',
    nbs: ['1.1405.30.00', '1.2603.00.00'],
  },
  {
    code: '250301',
    subitem: '25.03',
    name: 'Planos ou convênio funerários',
    group: 'Planos ou convênio funerários',
    nbs: ['1.2603.00.00'],
  },
  {
    code: '250401',
    subitem: '25.04',
    name: 'Manutenção e conservação de jazigos e cemitérios',
    group: 'Manutenção e conservação de jazigos e cemitérios',
    nbs: ['1.2603.00.00'],
  },
  {
    code: '250501',
    subitem: '25.05',
    name: 'Cessão de uso de espaços em cemitérios para sepultamento',
    group: 'Cessão de uso de espaços em cemitérios para sepultamento',
    nbs: ['1.2603.00.00'],
  },
  {
    code: '260101',
    subitem: '26.01',
    name: 'Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas',
    group: 'Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres',
    nbs: ['1.0501.15.00', '1.0608.10.00', '1.0701.00.00', '1.0702.00.00', '1.0703.00.00', '1.1802.40.00'],
  },
  {
    code: '260102',
    subitem: '26.01',
    name: 'Serviços de courrier e congêneres',
    group: 'Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres',
    nbs: ['1.0501.15.00', '1.0608.10.00', '1.0701.00.00', '1.0702.00.00', '1.0703.00.00', '1.1802.40.00'],
  },
  {
    code: '270101',
    subitem: '27.01',
    name: 'Serviços de assistência social',
    group: 'Serviços de assistência social',
    nbs: ['1.2304.11.00', '1.2304.12.00', '1.2304.19.00', '1.2304.20.00', '1.2304.90.00'],
  },
  {
    code: '280101',
    subitem: '28.01',
    name: 'Serviços de avaliação de bens e serviços de qualquer natureza',
    group: 'Serviços de avaliação de bens e serviços de qualquer natureza',
    nbs: ['1.1404.14.00', '1.1001.30.00', '1.0902.10.00'],
  },
  {
    code: '290101',
    subitem: '29.01',
    name: 'Serviços de biblioteconomia',
    group: 'Serviços de biblioteconomia',
    nbs: ['1.1705.10.00', '1.1705.20.00'],
  },
  {
    code: '300101',
    subitem: '30.01',
    name: 'Serviços de biologia e biotecnologia',
    group: 'Serviços de biologia, biotecnologia e química',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '300102',
    subitem: '30.01',
    name: 'Serviços de química',
    group: 'Serviços de biologia, biotecnologia e química',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '310101',
    subitem: '31.01',
    name: 'Serviços técnicos em edificações e congêneres',
    group: 'Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '310102',
    subitem: '31.01',
    name: 'Serviços técnicos em eletrônica, eletrotécnica e congêneres',
    group: 'Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '310103',
    subitem: '31.01',
    name: 'Serviços técnicos em mecânica e congêneres',
    group: 'Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '310104',
    subitem: '31.01',
    name: 'Serviços técnicos em telecomunicações e congêneres',
    group: 'Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres',
    nbs: ['1.1415.00.00'],
  },
  {
    code: '320101',
    subitem: '32.01',
    name: 'Serviços de desenhos técnicos',
    group: 'Serviços de desenhos técnicos',
    nbs: ['1.1409.90.00'],
  },
  {
    code: '330101',
    subitem: '33.01',
    name: 'Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres',
    group: 'Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres',
    nbs: ['1.0204.00.00', '1.2606.00.00'],
  },
  {
    code: '340101',
    subitem: '34.01',
    name: 'Serviços de investigações particulares, detetives e congêneres',
    group: 'Serviços de investigações particulares, detetives e congêneres',
    nbs: ['1.1802.10.00'],
  },
  {
    code: '350101',
    subitem: '35.01',
    name: 'Serviços de reportagem e jornalismo',
    group: 'Serviços de reportagem, assessoria de imprensa, jornalismo e relações públicas',
    nbs: ['1.1401.31.00', '1.1401.32.00', '1.1704.10.00', '1.1704.20.00'],
  },
  {
    code: '350102',
    subitem: '35.01',
    name: 'Serviços de assessoria de imprensa',
    group: 'Serviços de reportagem, assessoria de imprensa, jornalismo e relações públicas',
    nbs: ['1.1401.31.00', '1.1401.32.00', '1.1704.10.00', '1.1704.20.00'],
  },
  {
    code: '350103',
    subitem: '35.01',
    name: 'Serviços de relações públicas',
    group: 'Serviços de reportagem, assessoria de imprensa, jornalismo e relações públicas',
    nbs: ['1.1401.31.00', '1.1401.32.00', '1.1704.10.00', '1.1704.20.00'],
  },
  {
    code: '360101',
    subitem: '36.01',
    name: 'Serviços de meteorologia',
    group: 'Serviços de meteorologia',
    nbs: ['1.1404.30.00'],
  },
  {
    code: '370101',
    subitem: '37.01',
    name: 'Serviços de artistas, atletas, modelos e manequins',
    group: 'Serviços de artistas, atletas, modelos e manequins',
    nbs: ['1.1806.81.00', '1.1806.82.00', '1.1806.83.00', '1.2506.00.00', '1.2503.10.00'],
  },
  {
    code: '380101',
    subitem: '38.01',
    name: 'Serviços de museologia',
    group: 'Serviços de museologia',
    nbs: ['1.2504.11.00', '1.2504.12.00'],
  },
  {
    code: '390101',
    subitem: '39.01',
    name: 'Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)',
    group: 'Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)',
    nbs: ['1.2002.20.00'],
  },
  {
    code: '400101',
    subitem: '40.01',
    name: 'Obras de arte sob encomenda',
    group: 'Obras de arte sob encomenda',
    nbs: ['1.1109.90.00', '1.2503.20.00'],
  },
  {
    code: '990101',
    subitem: '99.01',
    name: 'Serviços sem a incidência de ISSQN e ICMS',
    group: 'Serviços sem a incidência de ISSQN e ICMS',
    nbs: [],
  },
]);
